"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _queryString = _interopRequireDefault(require("query-string"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _reactRouterDom = require("react-router-dom");
var _core = require("core.ui-module_site-components");
var _AuthComponentLoader = _interopRequireDefault(require("../components/auth/AuthComponentLoader"));
var _AuthenticationLaunchController = _interopRequireDefault(require("../api/auth/AuthenticationLaunchController"));
var _ApplicationContext = require("../api/ApplicationContext");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _MessageResolver = require("../api/MessageResolver");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _authenticationLaunchController = /*#__PURE__*/new WeakMap();
class Launch extends _react.default.Component {
  constructor(props) {
    super(props);
    _classPrivateFieldInitSpec(this, _authenticationLaunchController, null);
    _defineProperty(this, "sendToLoginRoute", () => {
      // Handle bad tokens by redirecting to the login when the default login method is not token
      if (_ApplicationContext.ApplicationContext.getDefaultLoginMethod() !== 'token') {
        window.location.href = _ApplicationContext.ApplicationContext.getLoginPath();
      }
    });
    this.state = {
      authFailure: false,
      authComponent: 'InitializeAuthenticationLaunch',
      token: null
    };
    _classPrivateFieldSet(_authenticationLaunchController, this, new _AuthenticationLaunchController.default(this));
    this.proceed = this.proceed.bind(this);
    this.sendToLoginRoute = this.sendToLoginRoute.bind(this);
  }
  componentDidMount() {
    const {
      token
    } = _queryString.default.parse(window.location.search);
    const params = _queryString.default.parse(window.location.search);
    const {
      origin
    } = params;
    if (origin) {
      _core.PostMessage.registerTargetOrigins([origin]);
    }
    if (token) {
      const cleanToken = _dompurify.default.sanitize(token);
      this.setState({
        token: cleanToken
      });
    }
  }
  proceed(stepListener, step) {
    if (step == null) {
      _classPrivateFieldGet(_authenticationLaunchController, this).initialize(stepListener);
    } else {
      _classPrivateFieldGet(_authenticationLaunchController, this).proceed(stepListener, step);
    }
  }
  render() {
    const {
      customMessageResolver,
      location
    } = this.props;
    const {
      authComponent,
      authFailure,
      stepResponse,
      statusCode,
      message,
      token
    } = this.state;
    let auth401 = true;
    if (location && location.search) {
      if (token && token !== '401') {
        auth401 = false;
      }
    }
    const content = (0, _AuthComponentLoader.default)(authComponent, this.proceed, stepResponse, this.props);
    if (authFailure || auth401) {
      _SecurityContextHolder.SecurityContextHolder.reset();
      const {
        onAuthenticationFailure
      } = this.props;
      if (typeof onAuthenticationFailure !== 'undefined') {
        onAuthenticationFailure();
        return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
      }
      return /*#__PURE__*/_react.default.createElement(_core.ErrorNotification, null, /*#__PURE__*/_react.default.createElement(_MessageResolver.MessageResolver, {
        statusCode: statusCode,
        message: message,
        customMessageResolver: customMessageResolver,
        customMessage: "The link has expired, please request another."
      }));
    }
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, content);
  }
}
Launch.propTypes = {
  isFromLogout: _propTypes.default.bool,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  loginHeroPosition: _propTypes.default.string,
  loginHeroContent: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginLogo: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginAddon: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  site: _propTypes.default.shape({
    siteId: _propTypes.default.number.isRequired,
    siteName: _propTypes.default.string.isRequired,
    siteTitle: _propTypes.default.string.isRequired,
    siteSubTitle: _propTypes.default.string.isRequired,
    siteTag: _propTypes.default.string.isRequired,
    siteDescription: _propTypes.default.string.isRequired,
    welcomeTitle: _propTypes.default.string.isRequired,
    contactUsEmail: _propTypes.default.string.isRequired,
    framework: _propTypes.default.bool
  }),
  location: _propTypes.default.shape({
    search: _propTypes.default.string
  }),
  customMessageResolver: _propTypes.default.func,
  onAuthenticationFailure: _propTypes.default.func
};
Launch.defaultprops = {
  isFromLogout: false,
  loginHeroContent: undefined,
  loginHeroPosition: 'left',
  loginLogo: undefined,
  loginAddon: undefined,
  customMessageResolver: undefined,
  onAuthenticationFailure: undefined,
  site: undefined
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(Launch);
//# sourceMappingURL=Launch.js.map